var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10350",
    "data-name": "Group 10350",
    transform: "translate(-699 -3150)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1747",
    "data-name": "Ellipse 1747",
    cx: 21,
    cy: 21,
    r: 21,
    transform: "translate(699 3150)",
    fill: "#1f2133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-linkedin-in",
    "data-name": "Icon awesome-linkedin-in",
    d: "M3.068,13.708H.226V4.556H3.068ZM1.646,3.308A1.654,1.654,0,1,1,3.292,1.647,1.66,1.66,0,0,1,1.646,3.308Zm12.059,10.4H10.869V9.253c0-1.062-.021-2.423-1.478-2.423-1.478,0-1.7,1.154-1.7,2.347v4.532H4.849V4.556H7.574V5.8h.04A2.986,2.986,0,0,1,10.3,4.327c2.876,0,3.4,1.894,3.4,4.354v5.027Z",
    transform: "translate(713.865 3164.273)",
    fill: "#fff",
    opacity: 0.4
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLinkedin);
export default __webpack_public_path__ + "static/media/footerLinkedin.02b6e2f28d6a2cdc86a0fd5334e20a04.svg";
export { ForwardRef as ReactComponent };